export const sortByNumbersFuncFactory = (getValueFunc) => (a, b) => {

    let aVal = getValueFunc(a).replace(/^[^.\d]+/,"");
    let bVal = getValueFunc(b).replace(/^[^.\d]+/,"");

    if ((!aVal || !bVal) || (aVal === bVal)) {
        aVal = getValueFunc(a);
        bVal = getValueFunc(b);
    }

    const aSplit = aVal.split(' ')[0].split('.');
    const bSplit = bVal.split(' ')[0].split('.');

    const maxDepth = aSplit.length > bSplit.length ? aSplit.length : bSplit.length;
    for (let i = 0; i < maxDepth; i++) {
        const a = aSplit[i];
        const b = bSplit[i];

        if (a !== b) {
            if (!a && i > 0) return -1;
            if (!b && i > 0) return 1;

            if (parseInt(a) && parseInt(b) && parseInt(a).toString() === a && parseInt(b).toString() === b) return parseInt(a) - parseInt(b);

            return aVal > bVal ? 1 : (aVal === bVal ? 0 : -1);
        }
    }

    return aVal > bVal ? 1 : (aVal === bVal ? 0 : -1);
};

export const sortByNumbersFuncFactoryAlt = (getValueFunc) => (a, b) => {

    let aVal = parseFloat(getValueFunc(a)) || 0;
    let bVal = parseFloat(getValueFunc(b)) || 0;

    if ((!aVal || !bVal) || (aVal === bVal)) {
        aVal = getValueFunc(a).replace(/[^.\d]+/g,"");
        bVal = getValueFunc(b).replace(/[^.\d]+/g,"");
    }

    if ((!aVal || !bVal) || (aVal === bVal)) {
        aVal = getValueFunc(a);
        bVal = getValueFunc(b);
    }

    return aVal > bVal ? 1 : (aVal === bVal ? 0 : -1);
};